import React from "react";
import Help from "./Help";
import SysStatsMemReport from "./Report";
import View from "common/View";

const SysStatsMem = () => {
  return (
    <View
      title="System Memory Usage Over Time"
      Help={Help}
    >
      <SysStatsMemReport />
    </View>
  );
};

export default SysStatsMem;
